;(function(){module.exports = {
  mixins: [require('../../../shared/frontend/vue/vue-mixins')],
  props: {
    termsUrl: String
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return _c('div',{staticClass:"mini-rewards-terms"},[_c('h4',[_v(_s(t('js.modules.rewards.mini_legal.title')))]),_v(" "),_c('p',[_c('span',[_v(_s(t('js.modules.rewards.mini_legal.content')))]),_v(" "),_c('a',{attrs:{"href":termsUrl}},[_v(_s(t('js.modules.rewards.mini_legal.details')))])])])}}
__vue__options__.staticRenderFns = []
